/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { UserAction, UserActionType, loginSuccess, loginError, validateUserAction } from '../actions/userActions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of, from } from 'rxjs';
import { authClient } from '../api/auth/authClient';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import { VALIDATE_USER_ACTION_STATUS_CODE } from '../../utils/recaptcha';

export const loginInspectorEpic: Epic<UserAction> = (action$) => {
    return action$.pipe(
        ofType(UserActionType.LOGIN_INSPECTOR),
        switchMap((action) => {
            return from(authClient.inspectorLogin(action.payload)).pipe(
                map((respData) => {
                    return loginSuccess(respData);
                }),
                catchError((err: AxiosError) => {
                    if (err.response && err.response.status === VALIDATE_USER_ACTION_STATUS_CODE)
                        return of(validateUserAction(action.payload));
                    else
                        return of(
                            loginError(
                                parseError(
                                    err,
                                    i18n.t('AuthScreen.errors.loginError', { errorText: err.response?.statusText }),
                                ),
                            ),
                        );
                }),
            );
        }),
    );
};

export const loginOperatorEpic: Epic<UserAction> = (action$) => {
    return action$.pipe(
        ofType(UserActionType.LOGIN_OPERATOR),
        switchMap((action) => {
            const { formData } = action.payload;

            return from(authClient.operatorLogin(formData)).pipe(
                map((respData) => {
                    return loginSuccess(respData);
                }),
                catchError((err: AxiosError) =>
                    of(loginError(parseError(err, i18n.t('AuthScreen.errors.loginError')))),
                ),
            );
        }),
    );
};

export const loginTaxpayerEpic: Epic<UserAction> = (action$) => {
    return action$.pipe(
        ofType(UserActionType.LOGIN_TAXPAYER),
        switchMap((action) => {
            const { formData } = action.payload;

            return from(authClient.taxpayerLogin(formData)).pipe(
                map((respData) => {
                    return loginSuccess(respData);
                }),
                catchError((err: AxiosError) =>
                    of(loginError(parseError(err, i18n.t('AuthScreen.errors.loginError')))),
                ),
            );
        }),
    );
};
